/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.service('gtm', ['$filter', 'Account', function ($filter, Account) {

        var dataLayer = window.dataLayer = window.dataLayer || [];

        /*
         
        function getCategory(detail) {            
            if (detail.tags && detail.tags.length) {
                return detail.tags[0].names[1].name; //en category name
            }            
        }

        function getProduct(detail) {
            if (detail)
            return {
                name: detail.code,
                id: detail.id, 
                //'price': item.price,
                category: getCategory(detail)
            }
        }

        function getCartProduct(item) {
            if (item) {
                var product = getProduct(item.detail);
                if (product) {
                    product.quantity = item.paxCount;
                    return product;
                }
            }
        }

        function getCartProducts(items) {
            if (items) {
                var products = [];
                for (var i = 0; i < items.length; i++) {                    
                    products.push(getCartProduct(items[i]));
                }
                    
                return products;
            }
        }

this.productDetails = function (item) {
            if (item) {
                var obj = {
                    event: 'productDetails',
                    ecommerce: {
                        detail: {
                            products: [getProduct(item)]
                        }
                    }
                }
                this.push(obj);
            }
        }

        */

        this.push = function (obj) {
            dataLayer.push(obj);            
        }

        this.addToWishlist = function (id) {
            if (id && Account.user) {
                var obj = {
                    event: 'addToWishlist',
                    allenamento: id,
                    user: Account.user.id,
                    user_type: Account.user.profile
                }
                this.push(obj);
            }
        }

        this.removeFromWishlist = function (id) {
            if (id && Account.user) {                
                var obj = {
                    event: 'removeFromWishlist',
                    allenamento: id,                    
                    user: Account.user.id,
                    user_type: Account.user.profile
                }
                this.push(obj);
            }
        }

        /*
         
        this.addToCart = function (cart) {
            if (cart && cart.items && cart.items.length) {
                var obj = {
                    event: 'addToCart',
                    ecommerce: {
                        currencyCode: 'EUR',
                        add: {
                            products: [getCartProduct(cart.items[cart.items.length - 1])]
                        }
                    }
                }
                this.push(obj);
            }
        }

        this.removeFromCart = function (item) {
            if (item) {
                var obj = {
                    event: 'removeFromCart',
                    ecommerce: {
                        currencyCode: 'EUR',
                        remove: {
                            products: [getCartProduct(item)]
                        }
                    }
                }
                this.push(obj);
            }
        }

        this.checkout = function (cart) {   
            if (cart && cart.items && cart.items.length) {
                var obj = {
                    event: 'checkout',
                    ecommerce: {
                        checkout: {
                            actionField: { step: 1 },
                            products: getCartProducts(cart.items)
                        }
                    }
                }
                this.push(obj);
            }
        }

        this.buy = function (cart) {
            if (cart && cart.items && cart.items.length) {
                var paymentSelected = (cart.payment || { paymentType: 0 }).paymentType || 0;
                var paymentType = $filter('filter')(cart.payment.paymentTypes, { id: paymentSelected });
                var paymentCode = ''
                if (paymentType && paymentType.length>0 && paymentType[0].code)
                    paymentCode = paymentType[0].code;  

                var obj = {
                    event: 'checkout',
                    ecommerce: {
                        checkout: {
                            actionField: { step: 2, option: paymentCode },
                            products: getCartProducts(cart.items)
                        }
                    }
                }                
                this.push(obj);
            }
        }

        this.transaction = function (purchase,cart) {
            var obj = {
                event: 'transaction',
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: purchase.bookingFileCode,                         
                            revenue: purchase.totalAmountDetail.totalAmountAfterDiscount,                    
                            tax: purchase.totalAmountDetail.dueAmount - purchase.totalAmountDetail.totalAmountWithoutVat,
                            //'shipping': '5.99',
                            coupon: cart.markupCode || ''
                        },
                        products: getCartProducts(cart.items)
                    }
                }
            }            
            this.push(obj);
        }

        */
    }]);


}());